const SESSION_KEY = "comunicazioni.login";
const PREFIX = "comunicazioni.lette.";
let fallbackSession = "";
const fallbackRead = new Map();

export function nuovaSessioneComunicazioni() {
  fallbackSession = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  fallbackRead.clear();
  try {
    const previous = window.sessionStorage.getItem(SESSION_KEY);
    if (previous) window.localStorage.removeItem(PREFIX + previous);
    window.sessionStorage.setItem(SESSION_KEY, fallbackSession);
  } catch { /* Lo storage può essere disabilitato nel browser. */ }
}

function storageKey() {
  try {
    if (!window.sessionStorage.getItem(SESSION_KEY)) nuovaSessioneComunicazioni();
    return PREFIX + (window.sessionStorage.getItem(SESSION_KEY) || fallbackSession);
  } catch {
    if (!fallbackSession) nuovaSessioneComunicazioni();
    return PREFIX + fallbackSession;
  }
}

export function comunicazioniLette() {
  const key = storageKey();
  try {
    const ids = JSON.parse(window.localStorage.getItem(key) || "[]");
    return new Set(Array.isArray(ids) ? ids.map(String) : []);
  } catch {
    return new Set(fallbackRead.get(key) || []);
  }
}

export function segnaComunicazioniLette(messaggi) {
  const key = storageKey();
  const ids = comunicazioniLette();
  messaggi.forEach(m => ids.add(String(m.idComunicazione)));
  fallbackRead.set(key, [...ids]);
  try { window.localStorage.setItem(key, JSON.stringify([...ids])); } catch { /* Fallback in memoria. */ }
}
